// import Group from "../components/Icons/Group";
// import Enterprise from "../components/Icons/Enterprise";
// import Doctor from "../components/Icons/Doctor";
// import Truck from "../components/Icons/Truck";
import { Group, Enterprise, Doctor, Truck, Contributor } from "../components/Icons/index";

const menu_options = [
  {
    key: 1,
    value: "PERSONAS",
    icon: Group,
    url: "https://www.swissmedical.com.ar/prepagaclientes/"
  },
  {
    key: 2,
    value: "CORPORATIVO",
    icon: Enterprise,
    url: "https://www.swissmedical.com.ar/clinewsite/ecco/corporativo/index.php"
  },
  {
    key: 3,
    value: "PRESTADORES",
    icon: Doctor,
    url: "https://www.swissmedical.com.ar/prestadores/home/"
  },
  {
    key: 4,
    value: "PROVEEDORES",
    icon: Truck,
    url: "https://www.swissmedical.com.ar/proveedores/"
  },
  {
    key: 4,
    value: "COLABORADORES",
    icon: Contributor,
    url: "https://app.humand.co/"
  }
];

export default menu_options;
